export const PATHS = {
    HOME: '/',
    ABOUT_ACTION: '/about-action',
    KNOWLEDGE_BASE: '/knowledge-base',
    DISINFECTION_TECHNIQUES: '/disinfection-technique',
    ONLINE_TRAININGS: '/online-trainings',
    CONTACT: '/contact',
    LOGIN: '/login',
    REGISTER_CHOOSE: "/register-choose",
    REGISTRATION: '/registration',
    REGISTRATION_EMPLOYEE: '/register-employer',
    PASSWORD_UPDATE: '/password-update',
    RESET_PASSWORD_PAGE: '/reset-options',
    RESET_PASSWORD: '/reset-password',
    RESET_ACCESS: '/reset-access',
    CONFIRM_RESET_PASSWORD: '/confirm-reset-password',
    SET_NEW_PASSWORD: '/set-new-password',
    EMAIL_VERIFICATION_SUCCESS: '/email-verification-success',
    EMAIL_VERIFICATION_ERROR: '/email-verification-error',
    CONFIRM_EMAIL_ADDRESS: '/confirm-email-address',
    STYLEGUIDE: '/styleguide',
    HAND_HYGIENE: '/online-trainings/hand-hygiene',
    GENERATE_CERTIFICATE: '/certificate',
    SHOP: '/shop',
    BASKET: '/basket',
    SUBMIT_YOUR_ORDER: '/submit-your-order',
    EMPLOYEE_MANAGMENT: "/employee-management",
   
};

export const PATHS_HAND_HYGIENE = {
    QUIZ: `${PATHS.HAND_HYGIENE}/q/quiz`,
    INTRODUCTION: `${PATHS.HAND_HYGIENE}/issue-1`,
    PREPARINGYOURHANDSTOWORK: `${PATHS.HAND_HYGIENE}/issue-2`,
    PROPERHANDDISINFECTION: `${PATHS.HAND_HYGIENE}/issue-3`,
    PROPERHANDWASHING: `${PATHS.HAND_HYGIENE}/issue-4`,
    HANDHYGIENEANDMEDICALGLOVES: `${PATHS.HAND_HYGIENE}/issue-5`,
    FIVEMOMENTSHANDHYGIENE: `${PATHS.HAND_HYGIENE}/issue-6`,
};

export const PATH_INTRODUCTION = {
    INDEX: `${PATHS_HAND_HYGIENE.INTRODUCTION}/topic-1`,
};

export const PATH_PREPARINGYOURHANDSTOWORK = {
    INDEX: `${PATHS_HAND_HYGIENE.PREPARINGYOURHANDSTOWORK}/topic-1`,
};

export const PATH_PROPERHANDDISINFECTION = {
    INDEX: `${PATHS_HAND_HYGIENE.PROPERHANDDISINFECTION}/topic-1`,
};

export const PATH_PROPERHANDWASHING = {
    INDEX: `${PATHS_HAND_HYGIENE.PROPERHANDWASHING}/topic-1`,
};

export const PATH_HANDHYGIENEANDMEDICALGLOVES = {
    INDEX: `${PATHS_HAND_HYGIENE.HANDHYGIENEANDMEDICALGLOVES}/topic-1`,
};

export const PATH_FIVEMOMENTSHANDHYGIENE = {
    INDEX: `${PATHS_HAND_HYGIENE.FIVEMOMENTSHANDHYGIENE}/topic-1`,
};

export const ROUTES = {
    HOME: {
        path: PATHS.HOME,
        name: 'home',
        disabled: false,
    },
    ABOUT_ACTION: {
        path: PATHS.ABOUT_ACTION,
        name: 'aboutAction',
        disabled: false,
    },
    KNOWLEDGE_BASE: {
        path: PATHS.KNOWLEDGE_BASE,
        name: 'knowledgeBase',
        disabled: false,
    },
    DISINFECTION_TECHNIQUES: {
        path: PATHS.DISINFECTION_TECHNIQUES,
        name: 'disinfectionTechnique',
        disabled: false,
    },
    ONLINE_TRAININGS: {
        path: PATHS.ONLINE_TRAININGS,
        name: 'onlineTrainings',
        disabled: false,
    },
    HAND_HYGIENE: {
        path: PATHS.HAND_HYGIENE,
        name: 'onlineTrainings',
        disabled: false,
    },
    CONTACT: {
        path: PATHS.CONTACT,
        name: 'contact',
        disabled: false,
    },
    LOGIN: {
        path: PATHS.LOGIN,
        name: 'logIn',
        disabled: false,
    },
    REGISTRATION: {
        path: PATHS.REGISTRATION,
        name: 'register',
        disabled: false,
    },
    REGISTRATION_EMPLOYEE: {
        path: PATHS.REGISTRATION_EMPLOYEE,
        name: 'registerEmployee',
        disabled: false,
    },
    PASSWORD_UPDATE: {
      path: PATHS.PASSWORD_UPDATE,
      name: 'Zmień hasło',
    },
    RESET_PASSWORD_PAGE: {
        path: PATHS.RESET_PASSWORD_PAGE,
        name: 'resetPasswordPage',
        disabled: false,
    },
    RESET_PASSWORD: {
        path: PATHS.RESET_PASSWORD,
        name: 'resetPassword',
        disabled: false,
    },
    SET_NEW_PASSWORD: {
        path: PATHS.RESET_PASSWORD,
        name: 'setNewPassword',
        disabled: false,
    },
    REGISTER_CHOOSE: {
        path: PATHS.REGISTER_CHOOSE,
        name: 'registerChoose',
        disabled: false,
    },
    EMPLOYEE_MANAGMENT: {
        path: PATHS.EMPLOYEE_MANAGMENT,
        name: 'employeeManagement',
        disabled: false,
    },
};

export const navigationConfig = [
    ROUTES.ABOUT_ACTION,
    ROUTES.KNOWLEDGE_BASE,
    ROUTES.DISINFECTION_TECHNIQUES,
    ROUTES.HAND_HYGIENE,
    ROUTES.CONTACT,
];
